import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import {
    AlternativeAddressDto,
    CarrierShippingRuleDto,
    SavedShippingDataDto,
    ShippingTypeDto,
} from "@thkStore/Common/Types/Shipping/ShippingTypes";

export interface CarrierSavedShippingDataDto {
    carrierKey: string;
    entries: SavedShippingDataDto[];
}

export interface ShippingOptionsApiResult {
    shippingTypeOptions: ShippingTypeDto[];
    alternativeAddresses: AlternativeAddressDto[];
    savedShippingData: CarrierSavedShippingDataDto[];
    carrierRules: CarrierShippingRuleDto[];
}

interface GetShippingOptionsApiParameter extends ApiParameter {
    billToId?: string;
}

export function getShippingOptions(billToId?: string): Promise<ShippingOptionsApiResult> {
    const parameter: GetShippingOptionsApiParameter = billToId ? { billToId } : {};
    return get<ShippingOptionsApiResult>("/api/v1/shipping/options", parameter);
}
